export const MarketEvent = {
  MarketTrendClick: 'market_trend_click',
  // for trade crypto click, see trade event.

  SearchBarClick: 'search_bar_click',
  SearchHistoryClick: 'search_history_click',
  SearchHistoryBinClick: 'search_history_bin_click',

  TopTradersPositionsClick: 'top_traders_positions_click',
  TopTradersPositionsArrowClick: 'top_traders_positions_arrow_click',
  TopTradersPositionsLearnMoreClick: 'top_traders_positions_learn_more_click',
  TopTradersPositionsSeeRanksClick: 'top_traders_positions_see_ranks_click',
} as const;

export interface MarketEventDataType {
  [MarketEvent.MarketTrendClick]: {
    clicked_market_trend: 'up' | 'down';
    down_coin_count: number;
    up_coin_count: number;
  };

  [MarketEvent.SearchBarClick]: {
    is_history: boolean;
  };
  [MarketEvent.SearchHistoryClick]: {
    trade_type: 'perpetual' | 'spot';
    symbol: string;
  };

  [MarketEvent.TopTradersPositionsClick]: {
    symbol: string;
    profile_username: string;
    profile_id: string;
    profile_ranking: string;
    position: 'buy' | 'sell';
    entry_price?: number;
    position_open_duration: string; // `${number}m`
    event_location: 'market_tab' | 'trade_tab';
  };
  [MarketEvent.TopTradersPositionsArrowClick]: {};
  [MarketEvent.TopTradersPositionsLearnMoreClick]: {};
  [MarketEvent.TopTradersPositionsSeeRanksClick]: {};
}
